import { AnnotationsTable } from "../../../components/custom/growth/AnnotationsTable";
import { useFetch } from "../../../hooks/api";
import { useDates } from "../../../dates/DatesContext";
import { useAppSelector } from "../../../redux/hooks";
import { keepPreviousData } from "@tanstack/react-query";

const ChangeLog = ({ annotationEntityId, annotationEntityType }) => {
  const { group, start, end } = useDates();
  const channel = useAppSelector((state) => state.channel);
  const marketPlace = useAppSelector((state) => state.marketPlace);

  const { data: annotationData, isLoading: isAnnotationDataLoading } = useFetch(
    ["annotations", start, end, channel, annotationEntityId, marketPlace.marketPlace],
    "/api/annotations/",
    {
      groupby: group,
      ts_after: `${start.format("YYYY-MM-DD")}T00:00:00`,
      ts_before: `${end.format("YYYY-MM-DD")}T23:59:59`,
      marketplace: marketPlace.marketPlace,
      channel: channel.currentChannel === "amazon" ? "AMZ" : channel.currentChannel,
      [annotationEntityType]: annotationEntityId,
    },
    {
      placeholderData: keepPreviousData,
      enabled: !!annotationEntityId,
    },
  );

  return <AnnotationsTable data={annotationData?.data} isLoading={isAnnotationDataLoading} />;
};

export default ChangeLog;
